import type { LayoutPreset } from '@/visualization/services/viewport-layout-service';
import { ViewportType } from '@/visualization/viewports/types';

/**
 * EVAR default layout - SVG sheet, straightened CPR, 3D + oblique.
 */
export const LAYOUT_EVAR_DEFAULT: LayoutPreset = {
    name: 'evar-default',
    label: 'EVAR Default',
    rows: 3,
    cols: 3,
    viewports: [
        {
            slotKind: 'panel',
            id: 'svg-view',
            label: 'SVG View',
            panelId: 'evar-sizing-sheet',
            row: 1,
            col: 1,
            rowSpan: 3,
        },
        {
            slotKind: 'viewport',
            id: 'straight-view',
            label: 'Straight View',
            type: ViewportType.CPR_STRAIGHTENED,
            row: 1,
            col: 2,
            rowSpan: 3,
        },
        {
            slotKind: 'viewport',
            id: '3d-view',
            label: '3D View',
            type: ViewportType.VOLUME_3D,
            row: 1,
            col: 3,
            rowSpan: 2,
            options: { showOrientationWidget: true },
        },
        {
            slotKind: 'viewport',
            id: 'centerline-view',
            label: 'Centerline',
            type: ViewportType.SLICE_OBLIQUE,
            row: 3,
            col: 3,
            options: { showOrientationWidget: true },
        },
    ],
};

/**
 * CPR dual layout (2x2) — both CPR modes stacked on the left,
 * 3D volume spanning the full height on the right.
 */
export const LAYOUT_CPR_DUAL: LayoutPreset = {
    name: 'cpr-dual',
    label: 'CPR Dual + 3D',
    rows: 2,
    cols: 2,
    viewports: [
        {
            slotKind: 'viewport',
            id: 'cpr-straightened',
            label: 'CPR Straightened',
            type: ViewportType.CPR_STRAIGHTENED,
            row: 1,
            col: 1,
        },
        {
            slotKind: 'viewport',
            id: 'cpr-stretched',
            label: 'CPR Stretched',
            type: ViewportType.CPR_STRETCHED,
            row: 2,
            col: 1,
        },
        {
            slotKind: 'viewport',
            id: '3d-view',
            label: '3D Volume',
            type: ViewportType.VOLUME_3D,
            row: 1,
            col: 2,
            rowSpan: 2,
            options: { showOrientationWidget: true },
        },
    ],
};

/**
 * 3-column layout with CPR Straightened, sizing sheet panel, and 3D views.
 */
export const LAYOUT_THREE_COLUMNS: LayoutPreset = {
    name: 'three-columns',
    label: 'Three Columns (Straight, SVG, 3D)',
    rows: 1,
    cols: 3,
    viewports: [
        {
            slotKind: 'viewport',
            id: 'straight-view',
            label: 'Straight View',
            type: ViewportType.CPR_STRAIGHTENED,
            row: 1,
            col: 1,
        },
        {
            slotKind: 'panel',
            id: 'svg-view',
            label: 'SVG View',
            panelId: 'evar-sizing-sheet',
            row: 1,
            col: 2,
        },
        {
            slotKind: 'viewport',
            id: '3d-view',
            label: '3D View',
            type: ViewportType.VOLUME_3D,
            row: 1,
            col: 3,
            options: { showOrientationWidget: true },
        },
    ],
};

/** All EVAR-specific layout presets. */
export const EVAR_LAYOUTS: LayoutPreset[] = [LAYOUT_EVAR_DEFAULT, LAYOUT_CPR_DUAL, LAYOUT_THREE_COLUMNS];
